import React, { useState, useEffect, useRef, useContext } from 'react';
import HeaderDetails from "../../components/header/header_details";
import DataDetails from "../home/data-details/data-details";
import axios from 'axios';
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MenuContext } from "../../views/dashboard/admin/admin"; 

function VuelosNoFacturados() {
    const handleMenuClick = useContext(MenuContext);
    const [collapsed, setCollapsed] = useState(true);
        const [collapsed2, setCollapsed2] = useState(true);
        const [loading, setLoading] = useState(true);
        const [data, setData] = useState([]);
        const [totales, setTotales] = useState([]);
        const [year, setYear] = useState(true);
        const [week, setWeek] = useState(true);
        const [Estaciones, setEstaciones] = useState(true);
        const [MexDom, setMexDom] = useState(true);
        const [MexExpo, setMexExpo] = useState(true);
        const [Impo, setImpo] = useState(true);
        const [VuelosFacturados, setVuelosFacturados] = useState(true);
        const toggleCollapse = () => {
            setCollapsed(!collapsed);
        };
        const [page, setPage] = useState(1);
        const [hasMore, setHasMore] = useState(true);
        const containerRef = useRef(null);
        const [query, setQuery] = useState(window.location.search);

        const handleScroll = () => {
            const { scrollTop, clientHeight, scrollHeight } = containerRef.current;
            if (scrollTop + clientHeight >= scrollHeight - 1 && hasMore) {
                setPage((prevPage) => prevPage + 1);
            }
        };
    
        useEffect(() => {
            const container = containerRef.current;
            container.addEventListener('scroll', handleScroll);
            return () => container.removeEventListener('scroll', handleScroll);
        }, [hasMore]);

        const toggleCollapse2 = () => {
            setCollapsed2(!collapsed2);
        };

        const getDashboard = async () => {
          try {
            const searchParams = new URLSearchParams(window.location.search);
            // Obtener los parámetros de la URL
            const week = searchParams.get('week');
            const year = searchParams.get('year');
            var variables = "";
            if(week && year){
                variables = [{
                    'week': week,
                    'year': year
                }];
                setYear(year)
                setWeek(week)
            }else{
                setYear(0)
                setWeek(0)
            }
            if(week!=undefined && year!=undefined){
                const res = await axios.post(`${process.env.REACT_APP_URL_BACKEND}/dashboard/detail_no_invoice`, {
                    params:{
                        'week': week,
                        'year': year,
                        "page": page,
                        "limit": 500
                    },
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
                  },
                });
                if (res.data.code === 1){
                  setData((prevData) => [...prevData, ...res.data.results]);
                  setTotales(res.data.totales_semanas);
                  setLoading(false)
                } else {
                  setHasMore(false);
                  console.error("ya no hay más datos");
                }
            }
          } catch (error) {
            Swal.fire("Error", "Hubo un error", "error");
            setLoading(true);
          }
        };

        useEffect(() => {
            const fetchDashboardAndLogDates = async () => {
                await getDashboard();  // Espera a que getDashboard se complete
            };
            
            fetchDashboardAndLogDates()// Llama a la función asíncrona
        }, [page]); 

        useEffect(() => {
            const handleResize = () => {
              // Check if window width is greater than or equal to 'md' breakpoint
              if (window.innerWidth >= 768) {
                // Reset collapse state when window size is 'md' or larger
                setCollapsed(true);
                setCollapsed2(true);
              }
            };

            // Add event listener to window resize event
            window.addEventListener('resize', handleResize);

            // Remove event listener when component unmounts
            return () => {
              window.removeEventListener('resize', handleResize);
            };
          }, []);

        useEffect(() => {
            const tbody = document.getElementById('main-data');
            tbody.innerHTML = '';
            if (data.length > 0 && !loading) {
                var pedro = 1;
                data.forEach((row) => {
                    const tr = document.createElement('tr');

                    // Crear y agregar las celdas <td> para cada propiedad del objeto
                    const tdId = document.createElement('td');
                    tdId.textContent = pedro;
                    tr.appendChild(tdId);

                    const td0 = document.createElement('td');
                    td0.textContent = row.folio_fiscal;
                    tr.appendChild(td0);

                    const td1 = document.createElement('td');
                    td1.textContent = row.folio_fiscal;
                    tr.appendChild(td1);

                    const td2 = document.createElement('td');
                    td2.textContent = row.clave;
                    tr.appendChild(td2);

                    const td3 = document.createElement('td');
                    td3.textContent = row.anio;
                    tr.appendChild(td3);

                    const td4 = document.createElement('td');
                    td4.textContent = row.semana;
                    tr.appendChild(td4);

                    const td5 = document.createElement('td');
                    td5.textContent = row.tiempo_demora;
                    tr.appendChild(td5);

                    const td6 = document.createElement('td');
                    td6.textContent = 'AMC';
                    tr.appendChild(td6);

                    const td7 = document.createElement('td');
                    td7.textContent = row.origen;
                    tr.appendChild(td7);

                    const td8 = document.createElement('td');
                    td8.textContent = row.destino;
                    tr.appendChild(td8);

                    const td9 = document.createElement('td');
                    td9.textContent = row.guias;
                    tr.appendChild(td9);

                    const td10 = document.createElement('td');
                    td10.textContent = row.importe_mx;
                    tr.appendChild(td10);

                    const td11 = document.createElement('td');
                    td11.textContent = row.kgsFact;
                    tr.appendChild(td11);

                    const td12 = document.createElement('td');
                    td12.textContent = '-';
                    tr.appendChild(td12);

                    // Agregar la fila <tr> al <tbody>
                    tbody.appendChild(tr);
                    pedro++;
                });
                setEstaciones(totales[0].sem_actual_estaciones_este_vuelo);
                setMexDom(totales[0].sem_actual_mex_dom_esta_semana);
                setMexExpo(totales[0].sem_actual_mex_expo_esta_semana);
                setImpo(totales[0].sem_actual_impo_esta_semana);
                setVuelosFacturados(totales[0].vuelos_sem_actual_facturados_esta_semana);

            }

            
        }, [data, totales]);

        const exportToExcel = () => {
          // Obtener la tabla principal existente en la vista
          const mainTable = document.getElementById('main-table');

          // Crear un objeto de hoja de cálculo vacío para la tabla principal
          const wsMain = XLSX.utils.table_to_sheet(mainTable);

          // Obtener la tabla secundaria existente en la vista
          const secondaryTable = document.getElementById('secondary-table');

          // Crear un objeto de hoja de cálculo vacío para la tabla secundaria
          const wsSecondary = XLSX.utils.table_to_sheet(secondaryTable);

          // Crear un libro de trabajo y añadir las hojas de cálculo
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, wsMain, 'Vuelos NO Facturados');
          XLSX.utils.book_append_sheet(wb, wsSecondary, 'Totales');

          // Escribir el libro de trabajo en formato binario
          const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

          // Convertir el binario a ArrayBuffer
          const buffer = new ArrayBuffer(wbout.length);
          const view = new Uint8Array(buffer);
          for (let i = 0; i < wbout.length; i++) {
            view[i] = wbout.charCodeAt(i) & 0xff;
          }

          // Crear un Blob y descargar el archivo
          const fileName = 'vuelos_no_facturados.xlsx';
          const blob = new Blob([buffer], { type: 'application/octet-stream' });
          saveAs(blob, fileName);
        };

        useEffect(() => {
            setQuery(window.location.search);
            getDashboard(); // Ejecutar cuando cambia la URL
          }, [window.location.search]); 
        return (
            <div className="main-section">
                <div className="row mt-4 px-4">
                    <div className="col-12 d-flex align-items-end justify-content-center mt-2">
                       <p className=""><b>Vuelos No facturados</b></p>
                    </div>
                    <div className="col-12 d-flex align-items-end justify-content-end mb-3">
                        <span className={`d-flex text-decoration-none justify-content-around blue-pill`} onClick={exportToExcel}>
                            <div>
                                <p className="fs-11 mt-2 mb-2 me-3 ms-3">Exportar</p>
                            </div>
                        </span>
                    </div>
                    <div className="col-12 d-block d-md-none mb-4 c-pointer" onClick={toggleCollapse}>Tabla 1</div>
                    <div className={`col-md-2 fs-10 ${collapsed ? '' : 'd-none'}`}>
                        <table className="table table-hover" id="secondary-table">
                            <thead>
                                <tr className="bg-color-gray">
                                    <th className="bg-color-gray text-white">Semana</th>
                                    <th className="bg-color-gray text-white">Concepto</th>
                                    <th className="bg-color-gray text-white">Total</th>
                                </tr>
                            </thead>
                            <tbody className="text-center">
                                <tr className="bg-color-gray">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr className="bg-color-gray">
                                    <td rowSpan="5">{ year%10 }{ week }</td>
                                   <td>Estaciones</td>
                                   <td>{ Estaciones }</td>
                                </tr>
                                <tr className="bg-color-gray">
                                   <td>Mex Dom</td>
                                   <td>{ MexDom }</td>
                                </tr>
                                <tr className="bg-color-gray">
                                   <td>Mex Expo</td>
                                   <td>{ MexExpo }</td>
                                </tr>
                                <tr className="bg-color-gray">
                                   <td>Impo</td>
                                   <td>{ Impo }</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-12 d-block d-md-none mb-4 c-pointer" onClick={toggleCollapse2}>Tabla 2</div>
                    <div className={`col-md-10 fs-10 table-responsive ${collapsed2 ? '' : 'd-none'}`} ref={containerRef}>
                        <table className="table table-hover" id="main-table">
                            <thead>
                                <tr>
                                    <th className="bg-color-softblue text-white rounded-table-left">#</th>
                                    <th className="bg-color-softblue text-white">Folio Fiscal</th>
                                    <th className="bg-color-softblue text-white">Concepto</th>
                                    <th className="bg-color-softblue text-white">Clave</th>
                                    <th className="bg-color-softblue text-white">Año</th>
                                    <th className="bg-color-softblue text-white">Semana</th>
                                    <th className="bg-color-softblue text-white">Tiempo Demora</th>
                                    <th className="bg-color-softblue text-white">Emisor</th>
                                    <th className="bg-color-softblue text-white">Origen</th>
                                    <th className="bg-color-softblue text-white">Destino</th>
                                    <th className="bg-color-blue text-white">Guías</th>
                                    <th className="bg-color-blue text-white">Importe MX</th>
                                    <th className="bg-color-blue text-white">Kgs Fac</th>
                                    <th className="bg-color-blue text-white rounded-table-right">Tarifa</th>
                                </tr>
                            </thead>
                            <tbody id="main-data">
                                
                            </tbody>
                        </table>

                    </div> 
                </div>
            </div>
        )
};

export default VuelosNoFacturados;